module.exports = __webpack_public_path__ + "static/media/nissan-street-selected.b7b20e6d.svg";